export const GET_TOKEN = 'GET_TOKEN';
export const SET_AUTHENTICATION_STATUS = 'SET_AUTHENTICATION_STATUS';
export const TOGGLE_NOTIFICATIONS_VISIBILITY = 'TOGGLE_NOTIFICATIONS_VISIBILITY';
export const UPDATE_APPS = 'UPDATE_APPS';
